<template>
<div class="cruise-info__dates">
    <div class="cruise-info__start">
        <div class="dd">{{ props.dates.dateStartOb.format(FORMAT1) }}</div>
        <div class="tt">{{ props.dates.dateStartOb.format(FORMAT2) }}</div>
    </div>
    <div class="cruise-info__duration">
        <span>{{numWord(props.dates.days)}}</span>
    </div>
    <div class="cruise-info__end">
        <div class="dd">{{ props.dates.dateEndOb.format(FORMAT1) }}</div>
        <div class="tt">{{ props.dates.dateEndOb.format(FORMAT2) }}</div>
    </div>
</div>
</template>

<script setup>
import '@/comp/CruiseInList/CruiseInList.scss' // чтобы стили не попадали в сборку дважды

import {computed} from 'vue'
import { numWord } from '@/util.js'

const FORMAT1 = 'D MMMM YYYY'
const FORMAT2 = computed( () => {
    return props.dates.is_cruise_time_published ? 'dd, HH:mm' : 'dd'
} )

const props = defineProps({
    dates: Object,
})

</script>